<template>
    <modal @close="closeModal" dusk="reset-password-server">
        <div class="field u-full-width">
            <div class="field u-full-width">
                <simple-text-input
                    v-model="vpsPassword"
                    :label="trans('page.vps.password-reset')"
                    name="vpsPassword"
                    input-class="field__input field__input-vpspassword"
                    dusk="input-password"
                    required
                />
            </div>
        </div>

        <div class="modal__nav">
            <button class="btn btn--ghost-gray btn-ghost--vps | u-margin-right" @click="closeModal">
                {{ trans('action.cancel') }}
            </button>
            <button class="btn btn--blue-record btn-ghost--vps" type="submit" dusk="submit-reset-password" @click="resetPassword">
                {{ trans('action.save') }}
            </button>
        </div>
    </modal>
</template>

<script>
import { EventBus } from 'relapp-event';
import { Modal } from 'relapp-modal';
import VpsApi from '../services/api/vps.js';
import {Way2Form} from "relapp-way2forms/src/way2forms";

export default {
    components: {
        Modal
    },
    props: {
        domain: {
            type: String,
            required: true
        },
        server: Object
    },
    data() {
        return {
            vpsPassword: '',
            vps: this.server,
        };
    },
    methods: {
        /**
         * Close the modal.
         */
        closeModal() {
            this.$emit('close');
        },

        /**
         * Reset server password
         */
        resetPassword() {
            VpsApi.resetPassword(this.domain, this.vps.data.id, new Way2Form({
                vpsPassword: this.vpsPassword
            }),).then(() => {
                EventBus.$emit('notification', {
                    type: 'success',
                    message: trans('action.saved')
                });
            })
            .catch(error => {
                this.showError(error);
            });

            this.$emit('close');
        }
    }
};
</script>
